var React = require('react');

function Invite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":" M 626 350.407 L 625.61 350.644 L 617.303 356.182 L 617 356.4 L 617 368.536 L 635 368.536 L 635 356.399 L 634.697 356.182 L 626.389 350.644 L 626 350.407 Z  M 626 352.072 L 633.096 356.81 L 626 362.132 L 618.904 356.81 L 626 352.072 Z  M 625.308 353.998 L 625.308 356.074 L 623.231 356.074 L 623.231 357.459 L 625.308 357.459 L 625.308 359.536 L 626.692 359.536 L 626.692 357.459 L 628.769 357.459 L 628.769 356.074 L 626.692 356.074 L 626.692 353.998 L 625.308 353.998 Z  M 618.385 358.151 L 625.589 363.56 L 626 363.863 L 626.411 363.56 L 633.615 358.151 L 633.615 367.151 L 618.385 367.151 L 618.385 358.151 Z "}));
}

Invite.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"617 350.407 18 18.129","width":"18","height":"18.129"};

module.exports = Invite;

Invite.default = Invite;
